module.exports = __webpack_public_path__ + "static/media/Banner-Web-PHU-THO.8faca9ad.png";